import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'

import { addNotification, Severity } from 'widget/Notifications'
import { DealerProductsResponse, LkmProductType } from '../types'

export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: getBaseQueryAuth,
  tagTypes: ['RegistrationDocument'],
  endpoints: builder => ({
    getDealerProductTypes: builder.query<LkmProductType[], void>({
      query: () => ({
        url: '/v1/fitter/dealer-product-list',
        method: 'GET',
      }),
      transformResponse: (response: DealerProductsResponse) =>
        (response.products || [])
          .filter(product => product.active)
          .map(product => ({
            id: product.uuid,
            value: product.name,
            code: product.code,
          })),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled
        } catch {
          dispatch(
            addNotification({
              text: 'Не удалось загрузить типы изделий. Попробуйте позже.',
              severity: Severity.error,
            }),
          )
        }
      },
    }),
    uploadRegistrationDocument: builder.mutation<{ documentId: string }, File>({
      query: file => {
        const formData = new FormData()
        formData.append('document', file)

        return {
          url: '/v1/fitter/registration-document',
          method: 'POST',
          body: formData,
        }
      },
      invalidatesTags: ['RegistrationDocument'],
    }),
    deleteRegistrationDocument: builder.mutation<{ message: string }, string>({
      query: documentId => ({
        url: '/v1/fitter/registration-document',
        method: 'DELETE',
        body: { documentId },
      }),
      invalidatesTags: ['RegistrationDocument'],
    }),
  }),
})

export const {
  useGetDealerProductTypesQuery,
  useUploadRegistrationDocumentMutation,
  useDeleteRegistrationDocumentMutation,
} = registrationApi
